<span class="content-container">

    <!-- Success -->
    <mat-icon *ngIf="'success' === data?.type" color="primary">check_circle</mat-icon>

    <!-- Failure -->
    <mat-icon *ngIf="'failure' === data?.type" color="error">error</mat-icon>

    <!-- Message -->
    {{data?.message}}

</span>

<!-- Dismiss Button -->
<span matSnackBarActions>
    <button mat-button mat-simple-snackbar-action color="primary" (click)="dismiss()"> {{data?.action ?? "dismiss"}}</button>
</span>